import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { useState } from "react";
import { SpinningLoader } from "../../SpinningLoader";
import { ChatAttachmentPreviewStyles } from "./ChatAttachmentPreview.styles";
export var ChatAttachmentPreview = function (props) {
    var image = props.image;
    var sx = ChatAttachmentPreviewStyles();
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(false), loadingFailed = _b[0], setLoadingFailed = _b[1];
    var handleLoadStart = function () {
        setIsLoading(true);
    };
    var handleLoad = function () {
        setIsLoading(false);
        setLoadingFailed(false);
    };
    return (_jsxs(Box, { sx: sx.wrapper, children: [(isLoading || loadingFailed) && _jsx(SpinningLoader, {}), !loadingFailed && image && (_jsx("img", { alt: "chatImage", src: image, onLoadStart: handleLoadStart, onLoad: handleLoad }))] }));
};
